import TimeRangePicker from './TimeRangePicker';

// export types
export type { TimeRangePickerProps } from './TimeRangePicker';

// export components
export { TimeRangePicker };
export default TimeRangePicker;
